export default {
  title: 'Terminal',
  stats: {
    terminal_battery_level: 'Nivel baterie',
    terminal_battery_state: 'Stare încărcare',
    auto_accept_orders: 'Acceptare automată comenzi',
  },
  auto_accept_orders_modal: {
    title: 'Ești sigur că vrei să activezi acceptarea automată a comenzilor?',
    buttons: {
      activate: 'Activează',
      cancel: 'Anulează',
    },
  },
  feedback: {
    update_success: 'Actualizat cu succes',
    update_failed: 'Nu s-au putut actualiza informațiile. Vă rugăm să încercați din nou.',
  },
};
